

















import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginLogout extends Vue {
  constructor() {
    super();
  }
  get reason() {
    let msg = "Erfolgreich ausgeloggt";
    if (this.$route.query.reason === "expired") {
      msg = "Nutzer Sitzung abgelaufen: Bitte erneut anmelden.";
    }
    return msg;
  }
  backToLogin() {
    this.$router.push({ path: "/login" });
  }
}
